<p-button
	(onClick)="toggle()"
	icon="pi pi-bars"
	size="small"
	severity="secondary"
	styleClass="!bg-white !text-gray-700 !border !border-gray-200 hover:!bg-gray-50"
	[pTooltip]="visible ? 'Recolher menu' : 'Expandir menu'"
/>